import type { QueueJob, JobStatus } from "./job-queue";

/**
 * Följer ett bakgrundsjobb tills det är klart. Körningen fortsätter på servern
 * även om man lämnar sidan – det här är bara för att kunna visa status direkt.
 */
export async function waitForJob(
  fetchJob: (jobId: string) => Promise<QueueJob>,
  jobId: string,
  onStatus?: (status: JobStatus, job: QueueJob) => void,
  options: { intervalMs?: number; timeoutMs?: number } = {},
): Promise<QueueJob> {
  const interval = options.intervalMs ?? 3000;
  const timeout = options.timeoutMs ?? 20 * 60 * 1000;
  const startedAt = Date.now();
  let last: QueueJob | null = null;

  for (;;) {
    try {
      const job = await fetchJob(jobId);
      const changed =
        last?.status !== job.status || (last?.progress?.step ?? null) !== (job.progress?.step ?? null);
      if (changed) onStatus?.(job.status, job);
      last = job;
      if (job.status === "done" || job.status === "failed" || job.status === "cancelled") return job;
    } catch {
      // Tillfälligt nätverksfel – vi försöker igen.
    }
    if (Date.now() - startedAt > timeout) {
      throw new Error("Körningen tar ovanligt lång tid. Du får en notis när den är klar.");
    }
    await new Promise((resolve) => setTimeout(resolve, interval));
  }
}
